import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, interpolate } from '@softline/core';
import {
  SOFTLINE_API_ABAU_DESPATCHADVICE_LINK,
  SOFTLINE_API_ABAU_DESPATCHADVICE_LINKS,
} from '../invoice-link.api';
import { LinkRequest, LinkResponse, UnlinkResponse } from '../types/despatchadvice-link';
import { DocumentId } from '../types/document-row';
import { linkServiceId } from '../functions/document-id';

/** Ids go out as bare numeric keys whatever shape the rows carry — see `linkServiceId`. */
@Injectable()
export class DespatchadviceLinkRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  createLink(request: LinkRequest): Promise<LinkResponse> {
    return this.dataAccess.create<LinkRequest, LinkResponse>(
      { path: SOFTLINE_API_ABAU_DESPATCHADVICE_LINKS },
      {
        invoiceVerificationId: linkServiceId(request.invoiceVerificationId),
        purchaseDeliveryNoteIds: request.purchaseDeliveryNoteIds.map((id) => linkServiceId(id)),
      }
    );
  }

  deleteLink(invoiceVerificationId: DocumentId): Promise<UnlinkResponse> {
    return this.dataAccess.delete<UnlinkResponse>({
      path: interpolate(SOFTLINE_API_ABAU_DESPATCHADVICE_LINK, {
        invoiceVerificationId: linkServiceId(invoiceVerificationId),
      }),
    });
  }
}
